// API
import { useRequests } from "@api/requests";

// Types
import type { UserService } from "@application/ports";
import type { UserGetAPIResponse, UserPutAPIData, UserPutAPIResponse } from "./user.types";

// Utils
import { ok } from "neverthrow";

export const useUserService = (): UserService => {
  const requestAPIV2 = useRequests();

  const userService: UserService = {
    async get() {
      const res = await requestAPIV2<UserGetAPIResponse>({
        url: "/users/me",
        method: "get",
      });

      return ok(res.data);
    },
    async put(params) {
      const res = await requestAPIV2<UserPutAPIResponse, UserPutAPIData>({
        url: "/users/me",
        method: "put",
        data: {
          language: params.language,
          name: params.name,
          timezone: params.timezone,
        },
      });

      return ok(res.data);
    },
  };

  return userService;
};
